import React, { useEffect } from "react";
import { Box, Divider, Stack, Typography, styled } from "@mui/material";
import Loader from "../../components/Loader";

import { useDispatch, useSelector } from "react-redux";
import { getBalanceSheet } from "./balanceSheetSlice";

const SubTitle = styled(Typography)({
  fontSize: "17px",
});

function BalanceSheet({ start, end }) {
  const dispatch = useDispatch();
  const {
    loading,
    purchaseLedgers,
    purchaseRemaining,
    saleLedgers,
    saleRemaining,
  } = useSelector((state) => state.balanceSheet);

  useEffect(() => {
    if ((start && end) || (!start && !end)) {
      dispatch(getBalanceSheet(start, end));
    }
  }, [start, end]);

  return (
    <Box>
      {!loading && (
        <Box sx={{ m: 5 }}>
          <SubTitle sx={{ fontWeight: 700 }} className="f-16">
            Accounts Receivable
          </SubTitle>
          <Divider />
          {saleLedgers?.map((item, i) => {
            return (
              <Stack
                key={i}
                direction="row"
                width="100%"
                justifyContent="space-between"
              >
                <SubTitle>{item.ledgerName}</SubTitle>
                <SubTitle>{item.remaining}</SubTitle>
              </Stack>
            );
          })}
          <Divider />
          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Total Accounts Receivable</SubTitle>
            <SubTitle>{saleRemaining}</SubTitle>
          </Stack>

          <SubTitle sx={{ mt: 5, fontWeight: 700 }} className="f-16">
            Accounts Payable
          </SubTitle>
          <Divider />
          {purchaseLedgers?.map((item, i) => {
            return (
              <Stack
                key={i}
                direction="row"
                width="100%"
                justifyContent="space-between"
              >
                <SubTitle>{item.ledgerName}</SubTitle>
                <SubTitle>{item.remaining}</SubTitle>
              </Stack>
            );
          })}
          <Divider />
          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Total Accounts Payable</SubTitle>
            <SubTitle>{purchaseRemaining}</SubTitle>
          </Stack>
        </Box>
      )}
      {loading && <Loader loading={loading} />}
    </Box>
  );
}
export default BalanceSheet;
